module.exports = __webpack_public_path__ + "img/expedia-logo.c3414a44.svg";